export function parseHashQueryParams(query: string) {
    const hashParams = query.slice(query.indexOf('?') + 1);
    const params = new URLSearchParams(hashParams);

    const result = {};
    for (const [key, value] of params.entries()) {
        result[key] = value;
    }

    return result;
}

export function parseHashPath(query: string) {
    const index = query.indexOf('?');
    const path = query.slice(query.indexOf('#') + 1, index === -1 ? query.length : index);
    return path;
}

export function getHashQueryParams(): { [key: string]: string } {
    return parseHashQueryParams(window.location.hash);
}

export function getHashQueryParam(key: string): string {
    return getHashQueryParams()[key];
}

export function getHashPath() {
    return parseHashPath(window.location.hash);
}

export function buildHashQueryParams(paramsMap: { [key: string]: any }) {
    const searchParams = new URLSearchParams();

    Object.entries(paramsMap || {}).forEach(([key, value]) => {
        if (typeof value !== 'undefined') {
            searchParams.set(key, value);
        }
    });

    const queryParams = searchParams.toString();

    return queryParams;
}
